// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"3aa79c97","112":"8c700b17","263":"17384e70","367":"91223855","594":"f7291594","688":"d3b059b5","981":"8357947a"}[chunkId] + ".chunk.js";
};